import React, { useRef } from 'react';

import Tippy from '@tippyjs/react';
import uniqBy from 'lodash/uniqBy';
import { useRecoilValue } from 'recoil';

import { hasModule, ia, iaRa } from 'lib/helpers/utility';
import usePortalNavigate from 'lib/hooks/usePortalNavigate';

import { modulesState } from 'components/state';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const NavigateToExternal = ({ data, node }) => {
  const ref = useRef();
  const navigate = usePortalNavigate();
  const practiceModules = useRecoilValue(modulesState);

  if (!!node?.group) return;

  if (!hasModule(practiceModules, 'medipay.payment_suite.electronic_invoicing')) return null;

  const uniqueExternalInvoices = uniqBy(iaRa(data.external_invoice_ids), (invoiceId) =>
    Number(invoiceId)
  );

  if (!ia(uniqueExternalInvoices)) return null;

  const handleClick = (invoiceId) =>
    navigate(`/portal/beyond-billing/electronic-invoicing/external?id=${invoiceId}`);

  return (
    <div className="flex">
      <div ref={ref}>
        {ia(uniqueExternalInvoices) && (
          <Typography variant="p" size="small" color="primary-800">
            External: {uniqueExternalInvoices.length}
          </Typography>
        )}
      </div>
      <Tippy
        allowHTML
        interactive
        theme="light"
        reference={ref}
        placement="right"
        offset={[0, 10]}
        appendTo={() => document.body}
        content={
          <div className="flex flex-col gap-1 p-2">
            {ia(uniqueExternalInvoices) && (
              <>
                <Typography variant="p" size="small" color="primary-800" weight="medium">
                  External Invoices
                </Typography>
                {uniqueExternalInvoices?.map((invoiceId) => (
                  <Button
                    key={invoiceId}
                    text={String(invoiceId)}
                    onClick={() => handleClick(invoiceId)}
                    variant="link"
                    size="small"
                  />
                ))}
              </>
            )}
          </div>
        }
      />
    </div>
  );
};

export default NavigateToExternal;
